export default __webpack_public_path__ + "static/media/reports-10.e78a5720.png";